import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import PointForm from "../components/PointForm";
import { useFetchWithToken } from "../auth/authorization";

export default function CreatePoint() {
    const navigate = useNavigate();
    const location = useLocation();
    const apiBase = process.env.REACT_APP_SERVER_API_URL || "";
    const base = apiBase.replace(/\/$/, "");
    const returnTo = location.state?.from ?? "/manage";

    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const fetchWithToken = useFetchWithToken();

    async function handleCreate(payload) {
        setError(null);
        setSaving(true);
        try {                                                             
            const res = await fetchWithToken(`${base}/api/point/create`, {
                method: "POST",
                body: JSON.stringify(payload)
            });

            const data = await res.json().catch(() => null);
            if (!res.ok) {
                const msg = (data && (data.message || data.Message)) || `HTTP ${res.status}`;
                throw new Error(msg);
            }
            navigate(returnTo);
        } catch (err) {
            console.error("Failed to create point:", err);
            setError(err instanceof Error ? err.message : String(err));
        } finally {
            setSaving(false);
        }
    }

    return (
        <main className="container py-4" style={{ maxWidth: 800 }}>
            <PointForm
                initialData={{}}
                title="Create Point"
                submitLabel="Create"
                saving={saving}
                externalError={error}
                onSubmit={handleCreate}
                onCancel={() => navigate(returnTo)}
            />
        </main>
    );
}